import React from 'react';
import HighlightFeature, { BOTTOM_LEFT } from '@/components/HighlightFeature';

export const BuildDashboardOnboarding = () => (
  <HighlightFeature
    position={BOTTOM_LEFT}
    text={
      <span>
        Build your dashboard by <b>adding saved queries</b>
      </span>
    }
    hideWhenModalsOpen
  />
);
